<div
  class="pointer-events-none fixed right-4 top-20 z-[60] flex flex-col gap-2"
  aria-live="polite"
  aria-atomic="false">
  @for (t of toasts(); track t.id) {
    <div
      class="pointer-events-auto transition-[opacity,transform] duration-150 ease-out"
      [class.opacity-0]="t.leaving"
      [class.-translate-y-1]="t.leaving">
      <app-toast [text]="t.text" [variant]="t.variant" (dismissed)="service.dismiss(t.id)" />
    </div>
  }
</div>
